import * as React from 'react';
import { ButtonGroup, FieldOpeningHours, styled } from '@lib/components';
import { FieldFeeSpecificDates } from './field-fee-specific-dates';

type DateSlot = T.Schema.Restaurant.Services.RestaurantServiceFeeDateSlot;
type RecurringSlot = T.Core.Business.BusinessHoursSlot;

type ScheduleTab = 'recurring' | 'specific';

interface Props {
  hours: RecurringSlot[];
  specific_dates: DateSlot[];
  onChangeHours: (hours: RecurringSlot[]) => void;
  onChangeSpecificDates: (specific_dates: DateSlot[]) => void;
}

function getInitialTab(hours: RecurringSlot[], specific_dates: DateSlot[]): ScheduleTab {
  if ((specific_dates || []).length > 0 && !(hours || []).length) {
    return 'specific';
  }
  return 'recurring';
}

const ButtonGroupDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  align-items: flex-start;

  & button:first-child {
    padding-right: 8px;
  }

  & button:last-child {
    padding-left: 8px;
  }
`
export const FieldFeeApplicableHours: React.FC<Props> = ({
  hours,
  specific_dates,
  onChangeHours,
  onChangeSpecificDates,
}) => {
  const [tab, setTab] = React.useState<ScheduleTab>(() =>
    getInitialTab(hours, specific_dates)
  );

  return (
    <ButtonGroupDiv>
      <ButtonGroup
        className="m-b-3"
        size="sm"
        width="auto"
        selected={tab}
        options={[
          { value: 'recurring', name: 'Recurring Schedule' },
          { value: 'specific', name: 'Specific Dates' },
        ]}
        onSelect={(selection) => setTab(selection.value as ScheduleTab)}
      />


      {tab === 'recurring' && (
        <FieldOpeningHours
          allowNone={true}
          hours={hours || []}
          onChange={onChangeHours}
        />
      )}

      {tab === 'specific' && (
        <FieldFeeSpecificDates
          dates={specific_dates || []}
          onChange={onChangeSpecificDates}
        />
      )}
    </ButtonGroupDiv>
  );
};
